import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
/* Cleaned lockup: the old CafevistaWhite.png was 7639x2836 (~83 MB decoded)
   rendered at 42px, and had the tagline baked in at ~4px tall. Swap this
   import for cafevista-lockup-cyan.png to use the cyan-icon variant. */
import logo from "../../assets/logos/cafevista-lockup.png";
import collabizLogo from "../../assets/logos/collabiz.svg";
import Icon from "../common/Icon";
import { subscribeNewsletter } from "../../config/api";
import { contact, products, solutionPillars, company } from "../../Data/siteContent";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const subscribe = async () => {
    if (email.trim() === "") return setMsg("Please enter your email");
    try {
      const data = await subscribeNewsletter(email.trim());
      setMsg(data.message || "Subscribed. Thanks for joining.");
      setEmail("");
    } catch (err) {
      setMsg(err.message || "Something went wrong. Please try again.");
    }
  };

  const socials = [
    { key: "instagram", href: contact.socials.instagram },
    { key: "facebook", href: contact.socials.facebook },
    { key: "youtube", href: contact.socials.youtube },
    { key: "linkedin", href: contact.socials.linkedin },
  ];

  return (
    <footer className="cv-footer">
      <div className="cv-footer__three" aria-hidden="true" />
      <div className="cv-grid-bg cv-footer__grid" />

      <div className="cv-footer__inner">
        {/* Newsletter bar */}
        <div className="cv-footer__news cv-glass">
          <div>
            <h3>Stay in the loop</h3>
            <p>Occasional notes on what we build and what we learn. No spam.</p>
          </div>
          <div className="cv-footer__news-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              aria-label="Email address"
            />
            <button className="cv-btn cv-btn--sm" onClick={subscribe} type="button">Subscribe</button>
          </div>
          {msg && <span className="cv-footer__news-msg">{msg}</span>}
        </div>

        {/* Main columns */}
        <div className="cv-footer__cols">
          <div className="cv-footer__brandcol">
            <Link to="/home" className="cv-footer__logo"><img src={logo} alt="CafeVista" /></Link>
            <p className="cv-footer__tagline">{company.tagline}</p>
            <div className="cv-footer__socials">
              {socials.map((s) => (
                <a key={s.key} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.key}>
                  <Icon name={s.key} size={18} />
                </a>
              ))}
            </div>
          </div>

          <div className="cv-footer__col">
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/products">Products</Link>
            <Link to="/contactus">Contact</Link>
            <Link to="/terms">Terms</Link>
          </div>

          <div className="cv-footer__col">
            <h4>Products</h4>
            {products.map((p) =>
              p.href && p.href.endsWith(".html") ? (
                <a key={p.id} href={p.href} target="_blank" rel="noopener noreferrer">
                  {p.name} <Icon name="arrow" size={13} />
                </a>
              ) : (
                <Link key={p.id} to={`/products#${p.id}`}>{p.name}</Link>
              )
            )}
          </div>

          <div className="cv-footer__col">
            <h4>Solutions</h4>
            {solutionPillars.map((s) => (
              <Link key={s.id} to={`/service#${s.id}`}>{s.name}</Link>
            ))}
          </div>

          <div className="cv-footer__col cv-footer__contact">
            <h4>Contact</h4>
            <a href={`mailto:${contact.email}`}><Icon name="mail" size={15} /> {contact.email}</a>
            <a href={`tel:${contact.phone}`}><Icon name="phone" size={15} /> {contact.phoneDisplay}</a>
            <span><Icon name="map" size={15} /> {contact.address}, {contact.region}</span>
            <span><Icon name="clock" size={15} /> {contact.hours}</span>
          </div>
        </div>

        {/* Group companies strip */}
        <div className="cv-footer__group">
          <span className="cv-footer__group-label">A Cafevista Pvt Ltd company</span>
          <div className="cv-footer__group-badges">
            {products.map((p) => (
              <span key={p.id} className={`cv-footer__badge cv-acc-${p.accent}`}>
                {p.logo ? <img src={collabizLogo} alt="" /> : <Icon name={p.icon} size={15} />}
                {p.name}
              </span>
            ))}
          </div>
        </div>

        <div className="cv-footer__bottom">
          © {new Date().getFullYear()} Cafevista Pvt Ltd. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
